<template>
  <div class="main_container">
    <img src="@/assets/Logo.svg" class="logo my-8" alt="" />
    <v-card class="login_card">
      <v-form ref="loginform" class="" @submit.prevent>
        <div class="welcome_text ml-3">
          WELCOME TO
          <span class="primary--text">COVESTO</span>
        </div>
        <div class="sub_text">Your trading success starts at Covesto</div>
        <div class="text-center">
          <img class="login_img mx-auto" :src="login_mobile_img" alt="" />
        </div>
        <v-card-text>
          <label class="login__mobile__label"
            >Mobile No.
            <v-text-field
              v-model="phone"
              @keypress="isNumber($event)"
              outlined
              height="46"
              @keyup.enter="login"
              background-color="#fff"
              dense
              maxlength="10"
              ref="mobile"
              prefix="+91 "
              :rules="[rules.required, rules.email]"
              hide-details
              placeholder=" Enter Mobile No."
            >
            </v-text-field>
          </label>
          <v-checkbox
            v-model="is_notification"
            label="I agree to recieve SMS and whatsapp notifictions"
            class="checkbox__class"
            hide-details
          >
            <template v-slot:label>
              <div style="white-space: wrap">
                <sapn class="checkbox_text">
                  I agree to recieve SMS and whatsapp notifications</sapn
                >
                <img class="wa_img ml-1" :src="whatsapp_image" alt="" />
              </div>
            </template>
          </v-checkbox>
        </v-card-text>
        <div class="action_div">
          <v-btn
            dense
            color="#2D8CFF"
            :loading="phoneLoader"
            class="login__form__btn"
            @click="login()"
            >Proceed</v-btn
          >
          <div class="divider">
            <p class="divider__p">or</p>
            <v-divider></v-divider>
          </div>

          <google-SSO-btn></google-SSO-btn>
          <facebook-SSO-btn
            v-if="showFacebookSSOButton"
            class="mt-3"
          ></facebook-SSO-btn>
          <p class="mt-6 agreement-disclaimer">
            By signing in, you agree to our
            <a
              target="_blank"
              href="https://docs.google.com/document/d/1sm4i6dfBknGjvzSn3w6uiCJQbCY-PPJjeIsSeii4EWE/edit?usp=sharing"
              class="anchor__text"
            >
              terms &amp; conditions
            </a>
            and
            <router-link :to="{ name: 'PrivacyPolicy' }" class="anchor__text">
              privacy policy</router-link
            >.
          </p>
        </div>
      </v-form>
    </v-card>
    <div class="d-flex justify-center align-center mt-14 lower_text grey--text">
      <div class="lower_text">Covesting Technologies</div>
      <v-divider vertical class="mx-2 py-2"></v-divider>
      <div class="lower_text">
        SEBI Reg. : <span class="blue--text">INH000015835</span>
      </div>
    </div>
  </div>
</template>

<!-- <v-form ref="loginform" class="login__form" @submit.prevent>
      <h3 class="d-none d-md-block title">Welcome to Covesto</h3>
      <label class="login__mobile__label"
        >Mobile No.
        <v-text-field
          v-model="phone"
          @keypress="isNumber($event)"
          outlined
          height="46"
          @keyup.enter="login"
          background-color="#fff"
          dense
          maxlength="10"
          ref="mobile"
          prefix="+91 "
          :rules="[rules.required, rules.email]"
          hide-details
          placeholder=" Enter Mobile No."
        >
        </v-text-field>
      </label>
      <p class="mobile-disclaimer">
        Mobile number is for authentication purpose only, won't be shared with
        anyone.
      </p>

      <v-checkbox
        v-model="is_notification"
        label="I agree to recieve whatsapp notifictions"
        class="checkbox__class"
      >
        <template v-slot:label>
          <div style="white-space: nowrap">
            I agree to recieve whatsapp notifications
            <v-icon color="#66ff66">mdi-whatsapp</v-icon>
          </div>
        </template>
      </v-checkbox>
      <v-btn
        dense
        color="#2D8CFF"
        :loading="phoneLoader"
        class="login__form__btn"
        @click="login()"
        >Proceed</v-btn
      >
      <div class="divider">
        <p class="divider__p">or</p>
        <v-divider></v-divider>
      </div>

      <google-SSO-btn></google-SSO-btn>
      <facebook-SSO-btn
        v-if="showFacebookSSOButton"
        class="mt-3"
      ></facebook-SSO-btn>

      <p class="mt-6 agreement-disclaimer">
        By signing in, you agree to our
        <a
          target="_blank"
          href="https://docs.google.com/document/d/1sm4i6dfBknGjvzSn3w6uiCJQbCY-PPJjeIsSeii4EWE/edit?usp=sharing"
          class="anchor__text"
        >
          terms &amp; conditions
        </a>
        and
        <router-link :to="{ name: 'PrivacyPolicy' }" class="anchor__text">
          privacy policy</router-link
        >.
      </p>
    </v-form> -->

<script>
import { mapActions } from "vuex";
import Axios from "../../../api/BaseAxios.js";
import GoogleSSOBtn from "@/components/GoogleSSOBtn";
import FacebookSSOBtn from "@/components/FacebookSSOBtn";
import ROUTER_URL from "@/constant/urls";
import { isAuthenticated } from "@/common/commonFunctions.js";
import ROUTING_HANDLER from "@/constant/routingHandler";

export default {
  name: "LoginForm",

  components: {
    GoogleSSOBtn,
    FacebookSSOBtn,
  },

  data: () => ({
    whatsapp_image: require("@/assets/images/whatsapp.png"),
    login_mobile_img: require("@/assets/images/login_mobile_img.png"),
    phone: "",
    phoneLoader: false,
    is_notification: true,
    rules: {
      required: (value) => !!value || "Required.",
      counter: (value) => value.length <= 10 || "Max 10 characters",
      email: (value) => {
        const pattern = /^[6-9]{1}[0-9]{9}$/;
        return pattern.test(value) || "Invalid phone number.";
      },
      isMobile: (value) => {
        if (value >= 2222222222 && value <= 9999999999) return true;
        return "Invalid Phone Number";
      },
    },
  }),

  methods: {
    ...mapActions("snackBar", ["showSnack"]),

    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    goToTermsofUse() {
      window.open(
        "https://docs.google.com/document/d/1sm4i6dfBknGjvzSn3w6uiCJQbCY-PPJjeIsSeii4EWE/edit?usp=sharing",
        "_blank"
      );
    },
    login() {
      localStorage.setItem("mobileNumber", this.phone);
      if (this.$refs.loginform.validate()) {
        this.phoneLoader = true;
        // console.log(this.phone.length);
        if (this.phone.length > 10 || this.phone.length < 10) {
          this.phoneLoader = false;
          return false;
        }
        // console.log(Axios);
        // console.log(this.phone);
        const successHandler = (res) => {
          console.log(res.data.message, res.data.verified, "success message");
          this.phoneLoader = false;
          // this.$store.state.Auth.checkStatus = "OTP";
          localStorage.setItem("user_id", res.data.user_id);
          localStorage.setItem("profile_id", res.data.profile_id);
          // localStorage.setItem("access", res.data.token.access);
          // localStorage.setItem("refresh", res.data.token.refresh);
          this.showSnack({
            text: `${res.data.message}`,
            color: "success",
            timeout: 4500,
          });
          this.$router.push(
            ROUTER_URL.auth.link + ROUTER_URL.auth.children.verifyOtp.link
          );
          this.$logEvent("login_successful");
          if (this.$vuetify.breakpoint.xsOnly) {
            this.$logEvent("mweb_login_successful");
          }
        };
        const errorHandler = (err) => {
          console.log(err, "this was error");
          this.showSnack({
            text: `${err.data.message}`,
            color: "error",
            timeout: 4500,
          });
          this.phoneLoader = false;
        };
        const data = {
          phone: this.phone,
          notification: this.is_notification,
        };
        Axios.request_POST(
          "/api/login/",
          data,
          {},
          successHandler,
          errorHandler,
          false,
          false
        );
      }
    },
  },
  created() {
    if (isAuthenticated()) {
      // const user_id = localStorage.getItem("user_id");
      // this.$router.push({ name: "HomePage", params: { id: user_id } });
      // this.$router.push({ name: ROUTER_URL.userPanel.children.trending.name });
      this.$router.push(ROUTING_HANDLER.getRoute());
    } else {
      this.$router.push({ name: "login" });
    }
  },

  async mounted() {
    await this.$firebase.remoteConfig().fetchAndActivate();
  },

  computed: {
    showFacebookSSOButton() {
      return Boolean(
        this.$firebase.remoteConfig().getValue("showFacebookSSOButton").value
      );
    },
  },
};
</script>

<style lang="scss">
.action_div {
  padding-right: 3%;
  padding-left: 3%;
}
.main_container {
  padding-left: 15%;
  padding-right: 15%;
  height: 100%;
}

.login_card {
  padding: 5%;
  border-radius: 12px;
}
.wa_img {
  height: 14px;
  width: 14px;
  margin-bottom: -3px;
}
.welcome_text {
  font-family: "Avenir" !important;
  font-weight: 900;
  font-size: 32px;
  line-height: 43.71px;
}

.v-date-picker-years {
  flex-direction: column !important;
}
.checkbox_text {
  font-family: "Avenir" !important;
  font-weight: 400;
  font-size: 14px;
  line-height: 19.21px;
}
</style>

<style scoped>
.lower_text {
  font-family: "Avenir" !important;
  font-weight: 500;
  font-size: 18px;
  line-height: 24.59px;
  color: #333333;
}
.theme--light.v-messages {
  display: none !important;
}
.sub_text {
  font-family: "Avenir" !important;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
  padding-left: 12px;
  display: none;
}
.login_img {
  display: none;
}
.title {
  font-family: "Avenir" !important;
  font-weight: 800;
  font-size: 34px;
  line-height: 46px;
  color: #333333;
  margin-bottom: 2.75rem;
}

.mobile-disclaimer {
  font-size: 11px;
  line-height: 18px;
  color: #eb5757;
  margin-top: 6px;
  margin-bottom: 20px;
}

.agreement-disclaimer {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #333333;
}

.login__mobile__label {
  font-size: 14px;
  line-height: 19px;
  font-weight: 400;
  color: rgba(51, 51, 51, 0.74);
}

.login__text__field {
  height: 46px;
  font-family: "Avenir";
  width: 100%;
  margin-bottom: 0px !important;
  border-radius: 10px;
  margin-top: 5px !important;
}

.text__field {
  font-family: "Avenir";
}

label {
  font-family: "Avenir";
}

.login__form__btn {
  color: #fff;
  height: 50px !important;
  letter-spacing: 0px;
  text-transform: capitalize;
  font-weight: bolder;
  font-size: 15px;
  border-radius: 6px;
  width: 100% !important;
}

.anchor__text {
  text-decoration: none;
  color: #2d8cff;
  padding-left: 0px;
}

.divider {
  margin: 2rem auto;
}

.divider__p {
  margin-bottom: -0.75rem;
  background: #f2f8ff;
  text-align: center;
  width: min-content;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  z-index: 3;
}
.logo {
  max-width: 191px;
  /*margin-bottom: 4.25rem;*/
}

/* } */
@media only screen and (max-width: 600px) {
  .login_card {
    width: 400px;
  }
  .main_container {
    padding-left: 5%;
    padding-right: 5%;
    height: 100%;
  }
  .sub_text {
    display: block; /* Display on mobile */
  }
  .login_img {
    display: block;
  }
  .welcome_text {
    font-family: "Avenir" !important;
    font-weight: 900;
    font-size: 22px;
    line-height: 30px;
  }
  .checkbox_text {
    font-family: "Avenir" !important;
    font-weight: 400;
    font-size: 12px;
    line-height: 16.39px;
  }
  .lower_text {
    font-family: "Avenir" !important;
    font-weight: 500;
    font-size: 12px;
    line-height: 24.59px;
    color: #333333;
  }
}
@media all and (min-width: 1300) {
  .login__form {
    width: 80% !important;
  }
}

@media all and (min-width: 1000px) {
  .login__form {
    padding: 10px 50px 20px 60px !important;
    width: 450px;
  }

  .login__text__field {
    height: 46px;
    /* width: 60%; */
    margin-top: 5px !important;
    margin-bottom: 25px !important;
    border-radius: 5px;
  }

  .login__form__btn {
    color: #fff !important;
    font-size: 18px !important;
    letter-spacing: 0px;
    border-radius: 5px;
    padding: 25px 5px !important;
    text-transform: capitalize;
    /* width: 21% !important; */
    margin-top: 10px !important;
    font-weight: bolder !important;
  }

  .divider__p {
    background: #fff;
  }

  .agreement-disclaimer {
    font-size: 14px;
    line-height: 19px;
  }
}
</style>
